import { gql } from "@apollo/client";

export const CaptureFragment = gql`
  fragment CaptureFragment on Capture {
    id
    captureId
    values
    status
    version
    definitionUpdatedAt
    createdAt
    updatedAt
  }
`;

// Beneath the workflow, which is the partition: there is no way to name a
// capture without first naming the workflow it answers.
export const list = gql`
  query CaptureList($workflowId: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        workflows {
          id
          get(workflowId: $workflowId) {
            id
            captures {
              id
              list(input: $input) {
                id
                last
                items {
                  ...CaptureFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${CaptureFragment}
`;

export const get = gql`
  query CaptureGet($workflowId: String!, $captureId: String!) {
    viewer {
      id
      account {
        id
        workflows {
          id
          get(workflowId: $workflowId) {
            id
            captures {
              id
              get(captureId: $captureId) {
                ...CaptureFragment
              }
            }
          }
        }
      }
    }
  }
  ${CaptureFragment}
`;

// Delete one response. Answers a bare boolean, so nothing lands in the cache
// on its own: the caller evicts the capture (see the Responses tab).
export const remove = gql`
  mutation CaptureRemove($workflowId: String!, $captureId: String!) {
    viewer {
      account {
        workflows {
          get(workflowId: $workflowId) {
            captures {
              id
              remove(captureId: $captureId)
            }
          }
        }
      }
    }
  }
`;
